module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedUltraBold.16902fe.woff2";